<template>
<div class="vue-funnel">
  <div
    v-for="(step, index) in steps"
    :key="index"
    class="vf-step"
    >
    <div class="vf-step-header">
      <h3>{{step.title}}</h3>
      <h3>{{step.total + step.positive}}</h3>
    </div>

    <div class="vf-progress">
      <div
        v-for="stepName in stepNames"
        :key="`${index}_${stepName}`"
        v-show="step.percentage[stepName] > 0"
        :class="`vf-bar vf-${stepName}`"
        :style="`width: ${step.percentage[stepName]}%;`"
        >
        <div class="vf-bar-quantity">
          {{step[stepName]}}
        </div>
        <div class="vf-bar-percentage">
          {{step.percentage[stepName]}}%
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'SalesFunnel',
  props: {
    value: Array,
    default: () => []
  },
  computed: {
    incomingTotal () {
      return this.value.reduce((globalTotal, step) => {
        let total = step.total + step.new
        return total > globalTotal ? total : globalTotal
      }, 0)
    },
    steps () {
      const nrOfSteps = this.value.length
      let incomingTotal = this.incomingTotal

      return this.value.map((step, index) => {
        const total = step.total
        let positive = step.new || 0
        let negative = index === nrOfSteps - 1
          ? 0
          : total - (this.value[index + 1].total - this.value[index + 1].new)
        const neutral = total - negative

        if (negative < 0) {
          negative = 0
          positive += -negative
        }

        return {
          ...step,
          negative,
          neutral,
          positive,
          percentage: {
            positive: Math.ceil(positive / incomingTotal * 1000) / 10,
            neutral: Math.ceil(neutral / incomingTotal * 1000) / 10,
            negative: Math.ceil(negative / incomingTotal * 1000) / 10
          }
        }
      })
    }
  },
  data () {
    return {
      stepNames: ['neutral', 'negative', 'positive']
    }
  }
}
</script>
<style scoped>
  .vue-funnel {

  }

  .vf-step-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .vf-step-header h3 {
    margin-bottom: 5px;
    display: inline-block;
  }

  .vf-progress {
    width: 100%;
    white-space: nowrap;
  }

  .vf-bar-quantity {
    font-weight: 700;
  }

  .vf-bar {
    position: relative;
    display: inline-block;
    height: 25px;
    line-height: 25px;
    padding-left: 5px;
    box-sizing: border-box;

    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    z-index: 1;
  }

  .vf-bar:hover {
    z-index: 2;
    padding-right: 30px;
    box-sizing: border-box;
  }

  .vf-bar-percentage {
    font-size: 12px;
  }

  .vf-neutral {
    background-color: #CCECFA;
    color: #73AEC8;
  }

  .vf-positive {
    background-color: #E7F5E4;
    color: #5E872E;
  }

  .vf-negative {
    background-color: #F5E4E4;
    color: #CB8B8B;
  }
</style>
